import backend from '@common/backend';

const BASE = '/polices';

export const getPolicies = async (query: any) => backend.get(`${BASE}/`, { params: query });

export const postPoliciesItem = async (data: any) => backend.post(`${BASE}`, data);

export const getPoliciesItem = async (id: number) => backend.get(`${BASE}/${id}`);

export const updatePoliciesItem = async (id: number, data: any) =>
	backend.put(`${BASE}/${id}`, data);

export const deletePoliciesItem = async (id: number) => backend.delete(`${BASE}/${id}`);
